import React from "react";

import { Icon } from '@types';

const RightArrowIcon: Icon = ({ fill = "#ffffff" }) => (
    <svg width="23" height="23" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="16.9712" y1="0.646447" x2="30.9712" y2="14.6464" stroke={fill}/>
      <line x1="16.2641" y1="28.6464" x2="30.2641" y2="14.6464" stroke={fill}/>
      <line x1="30.3173" y1="14.8813" x2="5.71767e-05" y2="14.8813" stroke={fill}/>
    </svg>
);

export default RightArrowIcon;
